<template>
  <div class="divider"></div>
</template>

<script>
export default {
  name: 'OrDivider'
}
</script>

<style lang="scss" scoped>
  .divider {
    position: relative;
    display: block;
    margin: 30px auto 20px;
    max-width: 308px;

    &:before  {
      position: relative;
      content: 'or';
      display: block;
      margin: 0 auto;
      height: 40px;
      width: 40px;
      color: #231F20;
      font-size: 18px;
      font-weight: 500;
      line-height: 38px;
      text-align: center;
      background-color: #DEDEDE;
      border-radius: 50%;
      z-index: 2;
    }

    &:after {
      content: '';
      position: absolute;
      top: 19px;
      right: 0;
      left: 0;
      border-bottom: 1px solid #eee;
      z-index: 1;
    }
  }
</style>
